module.exports = __webpack_public_path__ + "static/img/banner3.42065f42.png";